module.exports = __webpack_public_path__ + "static/media/Bone In Pork.b65f502f.jpg";